<template>
  <tr>
    <td class="koumoku keihiCont cwK_1">
      <input
        type="date"
        class="form-control form-control-sm"
        v-model="item.cnvExpensesDate"
        :disabled="isDisable"
      />
    </td>
    <td class="suuryou keihiCont cwK_2 selectBorderNone disableWhite">
      <vSelect
        :options="opType"
        v-model="item.c_expenses_type"
        class="ks_select"
        :reduce="(label:any) => label.code"
        :disabled="isDisable"
      ></vSelect>
    </td>
    <td class="tanka keihiCont cwK_3">
      <input
        type="text"
        class="form-control form-control-sm"
        v-model="item.c_expenses_payment_destination"
        :disabled="isDisable"
      />
    </td>
    <td class="kingaku keihiCont cwK_4">
      <input
        type="text"
        class="form-control form-control-sm"
        v-model="item.c_expenses_purpose"
        :disabled="isDisable"
      />
    </td>
    <td class="tanka keihiCont cwK_5">
      <input
        type="text"
        class="form-control form-control-sm"
        style="text-align: right"
        v-model="item.c_expenses_count"
        :disabled="isDisable"
      />
    </td>
    <td class="kingaku keihiCont cwK_6">
      <input
        type="text"
        class="form-control form-control-sm"
        @focus="kanmaDel($event)"
        @blur="kanmaIns($event)"
        style="text-align: right"
        v-model="item.cnvPrice"
        :disabled="isDisable"
      />
    </td>
    <td class="invoice keihiCont cwK_7 selectBorderNone disableWhite">
      <vSelect
        :selectable="kanmaIns4select()"
        :options="opInvoice"
        v-model="item.c_expenses_invoice"
        :reduce="(label:any) => label.code"
        :disabled="isDisable"
      ></vSelect>
    </td>
  </tr>
</template>
<script lang="ts">
import { Prop, Options, Vue, Watch } from "vue-property-decorator";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import {
  CONST_OP_TAXRATE,
  CONST_OP_EXPENSES_INVOICE,
  CONST_OP_EXPENSES_TYPE,
} from "furukawa-common/src/common/constant/Constants";
import { EntityRequestExpensesList } from "furukawa-common/src/common/entity/EntityRequestExpensesList";

@Options({
  components: {
    vSelect,
  },
})
export default class Mo_expenses_row extends Vue {
  //----------------------
  //DOM連携用プロパティ
  //----------------------
  @Prop({ required: true })
  item: EntityRequestExpensesList;
  @Prop({ required: true })
  isDisable: boolean;

  //----------------------
  //セレクトボックス用プロパティ
  //----------------------
  opTaxtate = CONST_OP_TAXRATE;
  opInvoice = CONST_OP_EXPENSES_INVOICE;
  opType = CONST_OP_EXPENSES_TYPE;
  //----------------------
  //モーダル用プロパティ
  //----------------------

  //----------------------
  //制御用メソッド
  //----------------------
  async mounted() {
    this.kanmaAdjust();
  }
  /**
   * 再計算イベントが発生した事を上位のコンポーネントに伝えるイベント発生
   */
  @Watch("item.cnvPrice")
  eventCalc() {
    //再計算イベント発生
    //-----------------------
    this.$emit("reCalc");
  }

  //----------------------
  //基本操作用メソッド
  //----------------------
  /**
   * 金額セル入力時の処理
   * カンマを消す
   * @param obj
   */
  kanmaDel(obj: any) {
    // //カンマを消す
    obj.target.value = obj.target.value.replace(/,/g, "");
    if (obj.target.value == "0") obj.target.value = "";
  }
  /**
   * 金額セル入力時の処理
   * カンマを付ける
   * @param obj
   */
  kanmaIns(obj: any) {
    let val: string = obj.target.value;

    //うっかり入力しているかもしれないカンマを消す
    val = val.replace(/,/g, "");
    //整数に変換したのち文字列に戻す
    //この時点で数字とマイナス記号だけが残る
    let num = "" + parseInt(val);
    //正規表現で桁区切りするための良く見かける関数的な何か
    //変数 num の中身が、桁区切りされる
    while (num != (num = num.replace(/^(-?\d+)(\d{3})/, "$1,$2")));
    //numに入っている値が数値じゃないときは空白とする
    if (isNaN(parseInt(num))) num = "";
    //桁区切りした結果（変数 num）でテキストボックスの中身を書き換える
    obj.target.value = num;
  }
  /**
   * インボイスのセレクトボックス選択時に、金額欄のカンマが消える問題に対応する為のメソッド。
   * セレクトボックス変更時に呼び出される。
   * @param obj
   */
  kanmaIns4select() {
    let val: string = this.item.cnvPrice;

    //うっかり入力しているかもしれないカンマを消す
    val = val.replace(/,/g, "");
    //整数に変換したのち文字列に戻す
    //この時点で数字とマイナス記号だけが残る
    let num = "" + parseInt(val);
    //正規表現で桁区切りするための良く見かける関数的な何か
    //変数 num の中身が、桁区切りされる
    while (num != (num = num.replace(/^(-?\d+)(\d{3})/, "$1,$2")));
    //numに入っている値が数値じゃないときは空白とする
    if (isNaN(parseInt(num))) num = "";
    //桁区切りした結果（変数 num）でテキストボックスの中身を書き換える
    this.item.cnvPrice = num;
  }

  kanmaAdjust() {
    // this.item.cnvPrice = this.item.cnvPrice!.replace(
    //   /^(-?\d+)(\d{3})/,
    //   "$1,$2"
    // );
    if (null != this.item.cnvPrice && this.item.cnvPrice != "") {
      while (
        this.item.cnvPrice !=
        (this.item.cnvPrice = this.item.cnvPrice.replace(
          /^(-?\d+)(\d{3})/,
          "$1,$2"
        ))
      );
    }
  }

  //----------------------
  //モーダル用メソッド
  //----------------------
}
</script>
<style scoped>
.tableKeihi tbody tr {
  border-bottom: 1px solid #ccc;
}

.tableKeihi td {
  border-right: 1px solid #ccc;
  height: 20px;
}
.tableKeihi tr > td:last-child {
  border-right: none;
}

.keihiCont > input {
  border: none;
  width: 100%;
}
.cwK_2 {
  min-width: 160px;
  max-width: 160px;
}
.cwK_3 {
  /* width: 20%; */
}
.cwK_4 {
  /* width: 40%; */
}
.cwK_5 {
  /* width: 5%; */
  min-width: 60px;
  max-width: 60px;
}
.cwK_6 {
  /* width: 10%; */
}
.cwK_7 {
  min-width: 100px;
  max-width: 100px;
}
/* .tableKeihi tr:hover td > input,
  .tableKeihi tr:hover td {
    background-color: #dddddd;
  } */

.titleMargin {
  margin: 15px 5px;
}

.titleKubetsu {
  border-radius: 0%;
  padding: 0.5rem;
}
.input-group-text {
  height: 30px;
  padding: 5px;
}

.isEdit input:disabled,
.isEdit textarea:disabled {
  background-color: #fff !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-radius: 0 !important;
}

.vs--disabled .vs__dropdown-toggle,
.vs--disabled .vs__clear,
.vs--disabled .vs__search,
.vs--disabled .vs__selected,
.vs--disabled .vs__open-indicator {
  background-color: #fff !important;
}
</style>
